import { init } from "i18next";

export const getInitForm = (match) => {
    const initForm = _.cloneDeep(match);

    initForm.name = initForm?.name ?? "";
    // Split the "name" field into "homeTeam" and "awayTeam"
    const [homeTeam, awayTeam] = initForm.name.split(" - ");
    initForm.homeTeam = homeTeam;
    initForm.awayTeam = awayTeam;

    if (typeof initForm.pitch === "number") {
        initForm.pitchID = initForm.pitch;
    }

    initForm.scheduleDate = initForm.scheduleDate
        ? new Date(initForm.scheduleDate)
        : null;
    initForm.scheduleTime = initForm.scheduleTime
        ? new Date(initForm.scheduleTime)
        : null;

    const locationObj = {
        id: initForm.locationID || match.location,
        locationName: initForm.location,
    };

    initForm.location = locationObj.id ? locationObj : null;

    initForm.status =
        initForm.matchStatusId !== undefined && initForm.matchStatusId !== null
            ? initForm.matchStatusId
            : initForm.status || null;

    if (initForm.status === null || initForm.status === undefined) {
        initForm.status = match.status;
    }

    return initForm;
};
